import MenuButton from "elements/MenuButton";

export default function MenuTaxes() {

    return (
        <div className='menu_button_container'>
            <MenuButton 
                label={"Taxes"}
                to={"/taxes"}
            />
            <MenuButton 
                label={"Tax Settings"}
                to={"/taxes/settings"}
            />
        </div>
    )
}